import { render, staticRenderFns } from "./DrawerAlert.vue?vue&type=template&id=27bbf39e&scoped=true"
import script from "./DrawerAlert.vue?vue&type=script&lang=js"
export * from "./DrawerAlert.vue?vue&type=script&lang=js"
import style0 from "./DrawerAlert.vue?vue&type=style&index=0&id=27bbf39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bbf39e",
  null
  
)

export default component.exports